import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "一级导航",
      isNav: true,
    },
    redirect: "/Inside-enterprise",
    children: [
      {
        path: "/Inside-enterprise",
        component: () => import("@/views/Inside/Inside-enterprise.vue"),
        meta: {
          title: "企业内部应用",
          isNav: true,
          keepAlive: true,
          icon: "icon-chanpinweihu",
        },
      },
      {
        path: "/Inside-detail",
        component: () => import("@/views/Inside/Inside-detail.vue"),
        meta: {
          title: "应用详情",
          isNav: false,
        },
      },
      {
        path: "/Third-party",
        component: () => import("@/views/Third/Third-party.vue"),
        meta: {
          title: "第三方企业应用",
          isNav: true,
          keepAlive: true,
          icon: "icon-yonghushenhe",
        },
      },
      {
        path: "/Third-detail",
        component: () => import("@/views/Third/Third-detail.vue"),
        meta: {
          title: "应用详情",
          isNav: false,
        },
      },
      {
        path: "/bond-manage",
        component: () => import("@/views/bond/bond-manage.vue"),
        meta: {
          title: "保证金管理",
          isNav: true,
          icon: "icon-kucun",
          isXuChangHidden: true,
        },
      },
      {
        path: "/bond-manage/bond-proof",
        component: () => import("@/views/bond//bond-proof.vue"),
        meta: {
          title: "上传缴费凭证",
          isNav: false,
        },
      },
      {
        path: "/order-list",
        component: () => import("@/views/order/order-list.vue"),
        meta: {
          title: "订单管理",
          isNav: true,
          icon: "icon-wuziguanli",
        },
      },
      {
        path: "/order-list/order-details",
        component: () => import("@/views/order/order-details.vue"),
        meta: {
          title: "订单详情",
          isNav: false,
        },
      },
      {
        path: "/pay-review",
        component: () => import("@/views/payreview/pay-review.vue"),
        meta: {
          title: "支付审核",
          isNav: true,
          icon: "icon-shengchanguanli",
          isXuChangHidden: true,
        },
      },
      {
        path: "/payreview/pay-reviewinfo",
        component: () => import("@/views/payreview/pay-reviewinfo.vue"),
        meta: {
          title: "审核详情",
          isNav: false,
        },
      },
      {
        path: "/refund-list",
        component: () => import("@/views/refund/refund-list.vue"),
        meta: {
          title: "退款管理",
          isNav: true,
          icon: "icon-shengchanguanli",
          isXuChangHidden: true,
        },
      },
      {
        path: "/refund-list/refund-details",
        component: () => import("@/views/refund/refund-details.vue"),
        meta: {
          title: "退款详情",
          isNav: false,
        },
      },
      {
        path: "/split-apply",
        component: () => import("@/views/split/split-apply.vue"),
        meta: {
          title: "交易账户配置",
          isNav: true,
          keepAlive: true,
          icon: "icon-shouli",
          isXuChangHidden: true,
        },
      },
      {
        path: "/revenue",
        component: () => import("@/views/statement/revenue.vue"),
        meta: {
          title: "营收总览",
          isNav: true,
          keepAlive: true,
          icon: "icon-tongji",
          isXuChangHidden: true,
        },
      },
      {
        path: "/statement",
        component: () => import("@/views/statement/statement.vue"),
        meta: {
          title: "对账管理",
          isNav: true,
          keepAlive: true,
          icon: "icon-chanpinweihu",
          isXuChangHidden: true,
        },
      },
      {
        path: "/statement-list",
        component: () => import("@/views/statement/statement-list.vue"),
        meta: {
          title: "对账明细",
          isNav: false,
        },
      },
      {
        path: "/statement-diff",
        component: () => import("@/views/statement/statement-diff.vue"),
        meta: {
          title: "对账差异记录",
          isNav: false,
        },
      },
      {
        path: "/settle",
        component: () => import("@/views/settle/settle.vue"),
        meta: {
          title: "结算管理",
          isNav: true,
          keepAlive: true,
          icon: "icon-weixiushangguanli",
          isXuChangHidden: true,
        },
      },
      {
        path: "/settle-list",
        component: () => import("@/views/settle/settle-list.vue"),
        meta: {
          title: "结算明细",
          isNav: false,
        },
      },
      {
        path: "/fee-invoice",
        component: () => import("@/views/invoice/fee-invoice.vue"),
        meta: {
          title: "平台资费发票",
          isNav: true,
          keepAlive: true,
          icon: "icon-shoukuan",
        },
      },
      {
        path: "/order-invoice",
        component: () => import("@/views/invoice/order-invoice.vue"),
        meta: {
          title: "交易开票申请",
          isNav: true,
          keepAlive: true,
        },
      },
      {
        path: "/connector",
        component: () => import("@/views/connector/index.vue"),
        meta: {
          title: "数据连接器",
          isNav: true,
          keepAlive: true,
        },
        children: [
          {
            path: "/connector-data",
            component: () => import("@/views/connector/connector-data.vue"),
            meta: {
              title: "连接器",
              isNav: true,
              keepAlive: true,
            },
          },
          {
            path: "/connector-flow",
            component: () => import("@/views/connector/connector-flow.vue"),
            meta: {
              title: "连接流",
              isNav: true,
              keepAlive: true,
            },
          },
          {
            path: "/connector-template",
            component: () => import("@/views/connector/connector-template.vue"),
            meta: {
              title: "流模板",
              isNav: true,
              keepAlive: true,
            },
          },
          {
            path: "/connector-detail",
            component: () => import("@/views/connector/connector-detail.vue"),
            meta: {
              title: "连接器详情",
              keepAlive: true,
            },
          },
          {
            path: "/create-trigger",
            component: () => import("@/views/connector/detail/create-trigger.vue"),
            meta: {
              title: "创建触发事件",
            },
          },
          {
            path: "/create-action",
            component: () => import("@/views/connector/detail/create-action.vue"),
            meta: {
              title: "创建执行动作",
            },
          },
        ],
      },
    ],
  },

  {
    path: "/login",
    component: () => import("../views/Login/login.vue"),
  },
  {
    path: "/forget",
    component: () => import("../views/Login/forget.vue"),
  },
  {
    path: "/register",
    component: () => import("../views/Login/register.vue"),
  },
  // {
  // 	path: '/join',
  // 	component: () => import('../views/Login/join.vue')
  // },
  // {
  // 	path: '/comp',
  // 	component: () => import('../views/Login/comp.vue')
  // },
  // {
  // 	path: '/createComp',
  // 	component: () => import('../views/Login/create.vue')
  // }
];

// const originalReplace = VueRouter.prototype.replace;
// VueRouter.prototype.replace = function replace(location) {
//     if (window.location.hash.slice(1) === location) {
//         return
//     }
//     return originalReplace.call(this, location).catch(err => err);
// };

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//     if (window.location.hash.slice(1) === location) {
//         return
//     }
//     return originalPush.call(this, location).catch(err => err)
// }

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  if (window.location.hash.slice(1) === location) {
    return;
  }
  return originalReplace.call(this, location).catch((err) => err);
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  if (window.location.hash.slice(1) === location) {
    return;
  }
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
